/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
const o = "listbox.moveUp", r = "listbox.moveDown", s = "listbox.transferTo", e = "listbox.transferFrom", t = "listbox.transferAllTo", n = "listbox.transferAllFrom", l = "listbox.remove", a = {
  [o]: "Move Up",
  [r]: "Move Down",
  [s]: "Transfer To",
  [e]: "Transfer From",
  [t]: "Transfer All To",
  [n]: "Transfer All From",
  [l]: "Delete"
};
export {
  a as messages,
  r as moveDown,
  o as moveUp,
  l as remove,
  n as transferAllFrom,
  t as transferAllTo,
  e as transferFrom,
  s as transferTo
};
